(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const cartButton = document.getElementsByClassName('js--open-cart')[0];
    if (cartButton) {
      cartButton.addEventListener('click', function () {
        window.Rebuy.SmartCart.show();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
